// extracted by mini-css-extract-plugin
export default {"marker":"Marker-module--marker--18f6a"};